<template>
  <div id="login-main">
    <!-- 广告 -->
    <div
      v-if="banner.current >= 0 && banner.show && !isRedirecting"
      ref="banner"
      class="banner animated slideInDown"
      :class="{ 'static-banner': isComponent }"
    >
      <i v-if="banner.queue[banner.current].icon" :class="banner.queue[banner.current].icon" />
      <span>{{ banner.queue[banner.current].text }}</span>
      <div class="close" v-if="!isComponent && banner.queue[banner.current].allowClose">
        <i class="anyteachicon anyteach-guanbi" @click="closeBanner('ad')" />
      </div>
    </div>
    <!-- 通用 -->
    <Top v-if="!isComponent && !isRedirecting" />
    <BottomBar v-if="!isComponent && !isRedirecting" />
    <div class="empty" v-if="isLoggedIn === undefined">
      <InlineLoading />
    </div>
    <!-- 微信内 -->
    <div v-else-if="$store.state.isWechat">
      <Wechat v-if="isRedirecting" />
      <Phone
        v-else-if="showPhone"
        v-on:complete="onPhoneComplete"
        v-on:coupon="onCoupon"
        :isComponent="isComponent"
      />
    </div>
    <!-- Web 端 -->
    <div v-else-if="!$store.state.isWechat">
      <Phone
        v-if="showPhone"
        :isComponent="isComponent"
        v-on:complete="onPhoneComplete"
        v-on:coupon="onCoupon"
      />
    </div>
    <!-- 通用 -->
    <div v-if="isLoggedIn && !showPhone" :class="{ full: !isComponent }">
      <Coupon
        v-if="coupon.length"
        :isComponent="isComponent"
        :coupon="coupon"
        v-on:next="next"
        v-on:complete="$emit('complete')"
      />
      <Logged v-else v-on:logout="logout" v-on:next="next" />
    </div>
  </div>
</template>
<script>
import Wechat from "./Wechat"
import Phone from "./Phone"
import Top from "./Top"
import Coupon from "./Coupon"
import Logged from "./Logged"
import Dialog from "mand-mobile/lib-vw/dialog"
import BottomBar from "@/components/public/footer"

export default {
  name: "Login",
  components: {
    Wechat,
    Phone,
    Top,
    Coupon,
    Logged,
    BottomBar,
  },
  props: {
    isComponent: {
      type: Boolean,
      default: false,
    },
    allowAd: {
      type: Boolean,
      default: true,
    },
    showHint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coupon: [],
      state: {
        timeouts: [],
      },
      banner: {
        current: -1,
        show: true,
        queue: [
          {
            text: "请先登录手机号",
            condition: this.$route.query.hint == 1 || this.showHint,
            duration: 3000,
            icon: false,
            allowClose: false,
          },
          {
            text: "新人注册即赠 100 元学习券",
            condition: false,
            duration: 0,
            icon: "anyteachicon anyteach-tishi",
            allowClose: true,
          },
        ],
      },
    }
  },
  computed: {
    isRedirecting() {
      return this.$route.query.wxLogin || this.$route.query.jwt
    },
    user() {
      return this.$store.state.user
    },
    isLoggedIn() {
      return this.$store.state.login
    },
    showPhone() {
      if (this.$store.state.isWechat) {
        return !this.user.mobile
      } else {
        return !this.isLoggedIn
      }
    },
  },
  watch: {
    coupon: function(value) {
      if (value.length) {
        this.banner.queue.push({
          text: `恭喜您，获得 ${value.length} 张学习券！`,
          condition: true,
          key: "hint",
          duration: 0,
          isLightBulb: false,
          allowClose: false,
        })
        this.showBanner(true)
      }
    },
  },
  mounted() {
    this.showBanner()
  },
  methods: {
    next() {
      const path = this.$route.query.from || "/"
      this.$router.replace(path)
    },
    onCoupon(coupon) {
      this.coupon = coupon
    },
    onPhoneComplete() {
      if (this.coupon.length) {
        return
      }
      if (this.isComponent) {
        return this.$emit("complete")
      }
      if (!this.isComponent) {
        return this.next()
      }
    },
    showBanner(showLast = false) {
      if (!this.banner.queue.filter(i => i.condition).length) {
        return this.closeBanner(false)
      }

      this.banner.show = true

      if (this.banner.current == this.banner.queue.length - 1) {
        return this.closeBanner(false)
      }

      if (showLast) {
        this.banner.current = this.banner.queue.length - 1
      } else {
        this.banner.current++
      }

      const current = this.banner.queue[this.banner.current]

      if (!current.condition) {
        return this.showBanner()
      }

      this.$nextTick(() => {
        this.$refs.banner.classList.remove("slideOutUp")
        this.$refs.banner.classList.add("slideInDown")
      })

      if (current.duration) {
        this.state.timeouts.push(
          setTimeout(() => {
            this.closeBanner()
          }, current.duration),
        )
      }
    },
    closeBanner(showNext = true) {
      const animationDuration = 500
      const interval = 1000
      if (this.$refs.banner) {
        this.$refs.banner.classList.remove("slideInDown")
        this.$refs.banner.classList.add("slideOutUp")
      }

      if (showNext) {
        this.state.timeouts.push(
          setTimeout(() => {
            this.showBanner()
          }, interval),
        )
      } else {
        this.state.timeouts.push(
          setTimeout(() => {
            this.banner.show = false
          }, animationDuration),
        )
      }
    },
    logout() {
      Dialog.confirm({
        title: "退出登录",
        content: "您确定要退出当前账号吗？",
        confirmText: "确认",
        cancelText: "取消",
        onConfirm: () => {
          this.$api.auth.LOGOUT().then(({ code, msg }) => {
            if (code == 1000) {
              this.$store.commit("login", false)
              this.$toastSuccess("退出成功")
            }
          })
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";

.empty {
  height: 50vh;
}
</style>
